import * as actionTypes from "./actionTypes";
import api from "./api";
import { showError } from "actions/actionCreators/snackbarActions";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { downloadAssetImage } from "features/asset/image/actionCreators";

const defaultLevelsOptions = { result: { dispatch: true, return: false } };
export function loadAssetHierarchyLevels(assetTypeId, editRight, options = defaultLevelsOptions) {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const hierarchyLevels = state.assetData.hierarchies[assetTypeId];
      const { viewType } = state.params.items;

      if (hierarchyLevels && hierarchyLevels.length > 0) {
        if (options.result.dispatch) {
          dispatch(setAssetHierarchyLevels(assetTypeId, hierarchyLevels, state, editRight, viewType));
        }
        if (options.result.return) {
          return hierarchyLevels;
        }
        return;
      }

      const levels = await dispatch(retrieveAssetHierarchyLevels(assetTypeId));
      dispatch(loadAssetHierarchyLevelsSuccess(assetTypeId, levels));
      if (options.result.dispatch) {
        dispatch(setAssetHierarchyLevels(assetTypeId, levels, state, editRight, viewType));
      }
      if (options.result.return) {
        return levels;
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export const retrieveAssetHierarchyLevels = assetTypeId => {
  return (dispatch, _) => {
    return dispatch(sendHttpRequest(api.getAssetHierarchyLevels(assetTypeId)));
  };
};

const loadAssetHierarchyLevelsSuccess = (id, levels) => {
  return {
    type: actionTypes.LOAD_ASSET_HIERARCHY_LEVELS_SUCCESS,
    payload: { id, levels }
  };
};

const setAssetHierarchyLevels = (id, levels, state, editRight, viewType) => {
  const bag = getBag(state, editRight);
  return {
    type: actionTypes.SET_ASSET_HIERARCHY_LEVELS,
    payload: { id, levels, bag, viewType }
  };
};

const getBag = (state, editRight) => {
  //the bag contains unused data for the actual context, but necessary for reducers that cannot access it because they manage another slice of state.
  const { vatPercent } = state.offerConfig;

  return {
    financedAssetDealerWrite: editRight,
    vatPercent
  };
};

export function checkAssetHierarchyTriggers(hierarchy) {
  return async dispatch => {
    const imageTriggers = hierarchy?.filter(z => z.triggers.image && z.id);
    if (imageTriggers.length === 0) return;

    imageTriggers.forEach(z => {
      dispatch(downloadAssetImage(z.id));
    });
  };
}

export const loadAssetHierarchyProperties = assetHierarchyId => {
  return async (dispatch, getState) => {
    const { assetHierarchyProperties } = getState().assetData.assetHierarchyProperties;
    if (assetHierarchyProperties) return;
    try {
      await dispatch({ type: actionTypes.LOAD_ASSET_HIERARCHY_PROPERTIES_STARTED });
      const properties = await dispatch(sendHttpRequest(api.getAssetHierarchyProperties(assetHierarchyId)));
      await dispatch({
        type: actionTypes.LOAD_ASSET_HIERARCHY_PROPERTIES_SUCCEEDED,
        payload: { id: assetHierarchyId, properties }
      });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
};

export function loadAssetTypes() {
  return async (dispatch, getState) => {
    const { assetTypes } = getState().assetData;
    if (assetTypes.isLoaded) return;

    try {
      await dispatch(sendHttpRequest(api.getAssetTypes())).then(assetTypes =>
        dispatch({ type: actionTypes.LOAD_ASSET_TYPES_SUCCEEDED, payload: { assetTypes } })
      );
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadAssetDefaults() {
  return async (dispatch, getState) => {
    try {
      let defaultAsset = getState().assetData.defaultAsset;
      if (defaultAsset.isLoaded) {
        return;
      }
      defaultAsset = await dispatch(sendHttpRequest(api.getAssetDefaults()));

      let payload = { defaultAsset };

      dispatch({ type: actionTypes.LOAD_ASSET_DEFAULTS_SUCCEEDED, payload });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function initAssetData() {
  return async dispatch => {
    await dispatch(loadAssetDefaults());
    await dispatch(loadAssetTypes());
  };
}

export function loadAssets(keyword, assetTypeId, buildYearAndMonth) {
  return async dispatch => {
    try {
      const assets = await dispatch(sendHttpRequest(api.getAssets(keyword, assetTypeId, buildYearAndMonth)));
      return assets;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function cacheAssetHierarchy() {
  return async dispatch => {
    try {
      await dispatch(sendHttpRequest(api.cacheAssetHierarchy()));
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}
